<template>
  <div
    :class="{
      'tree-navigation': true,
      'tree-navigation--long': structure.length > childLimit1,
      [`tree-navigation--level_${level}`]: true,
      'tree-navigation--last-level': isLastLevel,
      'tree-navigation--hide-nested': !showNested
    }"
  >
    <div
      class="tree-navigation__search | filter__search"
      v-if="structure.length > childLimit2"
    >
      <text-input
        ref="input"
        :label="$t('productlist.filter.search')"
        name="filter-search"
        autocomplete="off"
        v-model="inputValue"
        hide-label
        hide-mandatory-marker
      />
      <div class="input__button input__button--icon_search" />
    </div>

    <div class="tree-navigation__child-container">
      <ul
        class="tree-navigation__list"
        v-if="filteredStructure.length"
      >
        <li
          v-for="(item, index) in filteredStructure"
          :key="index"
          class="tree-navigation__item"
          :class="{
            'tree-navigation__item--active': item.active,
            'tree-navigation__item--has-children': item.hasChildren,
            'tree-navigation__item--open': item.children.length,
          }"
        >
          <component
            :is="item.linked ? 'a' : 'span'"
            :href="item.linked ? item.link : null"
            class="tree-navigation__label"
          >
            {{ item.name }}

            <span
              v-if="item.count !== null"
              class="tree-navigation__child-count"
            >
              ({{ item.count }})
            </span>
          </component>

          <tree-navigation
            v-if="item.children.length && showNested"
            :navigation-branches="item.children"
            :level="level + 1"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted} from 'vue';
  import LeftNavigationCategoryTree from './LeftNavigationCategoryTree';
  import TextInput from '../../../bps/components/input/TextInput.vue';
  import {usePlaceholder} from '../../utilities/vueMixins/placeholderMixin/placeholder';

  const props = withDefaults(defineProps<{
    navigationTree?: string, // json encoded LeftNavigationCategoryTree;
    navigationBranches?: LeftNavigationCategoryTree[],
    level?: number,
    showNested?: boolean
  }>(), {
    navigationTree: null,
    navigationBranches: null,
    level: 1,
    showNested: true
  });

  const childLimit1 = 12;
  const childLimit2 = 25;

  const structure = ref<LeftNavigationCategoryTree[]>(null);
  const isLastLevel = ref(false);
  const inputValue = ref('');
  const searchValue = computed(() => inputValue.value.trim());

  const filteredStructure = computed(() => {
    if (!searchValue.value) {
      return structure.value;
    }

    const regExp = new RegExp(searchValue.value, 'gi');
    return structure.value
      .filter(item => {
        return item.name.match(regExp);
      });
  });

  const parsedNavTree = props.navigationTree ? JSON.parse(props.navigationTree) : null;
  structure.value = parsedNavTree && parsedNavTree.children || props.navigationBranches;
  isLastLevel.value = true;
  for (let i = 0; i < structure.value.length; i++) {
    const item = structure.value[i];
    if (item.children.length > 0) {
      isLastLevel.value = false;
      break;
    }
  }

  onMounted(() => {
    usePlaceholder('tree-navigation');
  });
</script>
